import React, { useEffect, useState } from 'react';
import { Label, Input } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TASK_ACTION,
} from '../../utils/Constant';
import SearchIcon from '@mui/icons-material/Search';
import {
  ColXsMdType,
  MapOptionType,
  MUILocationFilterType,
  SelectOptionType,
} from '../../utils/Types';
import moment from 'moment';
import { leadSelector } from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { VIEW_LEADMOTORDETAILS_HEADER } from './LeadPageHelper';
import KTable from '../../components/KTable';
import {
  Autocomplete,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import DatePicker from '../../components/KDatePicker';

const blankLocationMotor = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
interface ICreateTaskMotorPageProps {
  leadStatus?: any;
  disabled?: any;
  leadMotorDetails?: any;
  leadMotorList?: any;
  setLeadMotorDetails: (data: any) => void;
  setLeadMotorList: (data: any) => void;
  selectedLeadTypeId: any;
  defaultLocationOptions: any;
  zoneName: any;
  stateName: any;
  districtName: any;
  villageName: any;
  locationData: any;
  inputValue: any;
  searchTerm: any;
  ifPincode: any;
  pincodeData: any;
  selectedPincodeData: any;
  setZoneName: (data: any) => void;
  setStateName: (data: any) => void;
  setDistrictName: (data: any) => void;
  setVillageName: (data: any) => void;
  setLocationData: (data: any) => void;
  setInputValue: (data: any) => void;
  setSearchTerm: (data: any) => void;
  setIfPincode: (data: any) => void;
  setPincodeData: (data: any) => void;
  setSelectedPincodeData: (data: any) => void;
  validateMotorLead: () => Promise<boolean>;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const MotorSectionPage: React.FunctionComponent<ICreateTaskMotorPageProps> = ({
  leadStatus,
  disabled,
  leadMotorDetails,
  leadMotorList,
  setLeadMotorDetails,
  setLeadMotorList,
  selectedLeadTypeId,
  defaultLocationOptions,
  zoneName,
  stateName,
  districtName,
  villageName,
  locationData,
  inputValue,
  searchTerm,
  ifPincode,
  pincodeData,
  selectedPincodeData,
  setZoneName,
  setStateName,
  setDistrictName,
  setVillageName,
  setLocationData,
  setInputValue,
  setSearchTerm,
  setIfPincode,
  setPincodeData,
  setSelectedPincodeData,
  validateMotorLead,
}: ICreateTaskMotorPageProps) => {
  const leadTypeRiskCoverage: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeRiskCoverage;
  const leadTypeVehicleType: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeVehicleType;
  const [leadTypeRiskCoverageDropOptions, setLeadTypeRiskCoverageDropOptions] =
    useState<SelectOptionType[]>([]);
  const [leadTypeVehicleTypeDropOptions, setLeadTypeVehicleTypeDropOptions] =
    useState<SelectOptionType[]>([]);

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const dispatch = useAppDispatch();

  useEffect(() => {
    setLeadTypeRiskCoverageDropOptions(leadTypeRiskCoverage);
  }, [leadTypeRiskCoverage]);

  useEffect(() => {
    setLeadTypeVehicleTypeDropOptions(leadTypeVehicleType);
  }, [leadTypeVehicleType]);

  const handleAddMotorLead = async () => {
    const isValid = await validateMotorLead();

    if (!isValid) {
      return;
    }

    console.log('locationData', locationData);

    setLeadMotorList((prev: any) => [
      ...prev,
      {
        id: Date.now(),
        ...leadMotorDetails,
        date: leadMotorDetails?.date
          ? moment(leadMotorDetails.date).format('YYYY-MM-DD')
          : '',
        timeframeOfPurchase: moment(
          leadMotorDetails?.timeframeOfPurchase
        ).format('YYYY-MM-DD'),
        state: Number(locationData.state),
        district: Number(locationData.district),
        city: Number(locationData.city),
        zone: Number(locationData.zone),
        pincode: locationData.pincode,
        zoneName,
        stateName,
        districtName,
        villageName,
        remove: 'Remove',
      },
    ]);
    console.log('villageName', villageName);
    // Clear inputs after adding
    setLeadMotorDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      riskCoverage: '',
      vehicleType: '',
      make: '',
      OwnerNameASPerRC: '',
      VehicleRegnNo: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      riskCoverageName: '',
      vehicleTypeName: '',
    });
    setLocationData(blankLocationMotor);
    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);
    setSelectedPincodeData({
      label: '',
      value: '',
    });
  };
  const handleRemoveMotorLead = (id: number) => {
    setLeadMotorList((prev: any) => prev.filter((item: any) => item.id !== id));
  };

  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };

  return (
    <div className="inner-div">
      <Row className="align-items-center mb-3">
        <Col xs={6}>
          <Label className="header-style mb-0">Lead Details</Label>
        </Col>

        {leadStatus == TASK_ACTION.CREATE && (
          <Col xs={6} className="text-end">
            <Button
              variant="primary"
              onClick={handleAddMotorLead}
              disabled={disabled}
            >
              Add Lead
            </Button>
          </Col>
        )}
      </Row>
      <Row className="mt-1">
        <Col xs={12} md={4}>
          <MTextField
            label="Lead First Name"
            required
            value={leadMotorDetails?.firstname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadMotorDetails({
                ...leadMotorDetails,
                firstname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <MTextField
            label="Lead Last Name"
            required={true}
            value={leadMotorDetails?.lastname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadMotorDetails({
                ...leadMotorDetails,
                lastname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MTextField
            label="Contact Number"
            required
            value={leadMotorDetails?.contactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadMotorDetails({
                  ...leadMotorDetails,
                  contactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Alternate Contact Number"
            required={false}
            value={leadMotorDetails?.alternateContactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadMotorDetails({
                  ...leadMotorDetails,
                  alternateContactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} md={5}>
          {leadStatus == TASK_ACTION.CREATE ? (
            <Autocomplete
              open={ifPincode}
              onOpen={() => setIfPincode(true)}
              onClose={() => setIfPincode(false)}
              options={pincodeData}
              getOptionLabel={(option) => String(option?.label)}
              value={selectedPincodeData ?? null}
              inputValue={inputValue}
              onInputChange={(event, newValue, reason) => {
                if (reason !== 'reset') {
                  const safeValue =
                    typeof newValue === 'string' ? newValue : '';
                  console.log('safeValue', safeValue);
                  setInputValue(safeValue);
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={async (event, newValue) => {
                console.log('newValue', newValue);
                if (newValue) {
                  const validZoneIds =
                    (await zoneOption.map((zone) => zone.value)) || [];
                  const validStateIds =
                    (await Object.values(allStates).flatMap((group) =>
                      group.map((item) => item.value)
                    )) || [];
                  const districtsLength =
                    (await Object.keys(districtData).length) ?? 0;
                  if (
                    !validZoneIds.includes(String(newValue.zoneId)) ||
                    !validStateIds.includes(String(newValue.stateId)) ||
                    districtsLength == 0
                  ) {
                    alert('This location isn’t within your assigned region');
                    setInputValue('');
                    setPincodeData([]);
                    setLocationData(blankLocationMotor);
                    return;
                  }
                  setSearchTerm(true);
                  setSelectedPincodeData(newValue);
                  setLocationData({
                    ...locationData,
                    zone: newValue.zoneId,
                    state: newValue.stateId,
                    district: newValue.districtId,
                    city: newValue.villageId,
                    pincode: newValue.pincode,
                  });
                  setZoneName(newValue.zoneName);
                  setStateName(newValue.stateName);
                  setDistrictName(newValue.districtName);
                  setVillageName(
                    newValue.mandalName
                      ? newValue.mandalName + '-' + newValue.villageName
                      : newValue.villageName
                  );
                } else {
                  setInputValue('');
                  setPincodeData([]);
                  setLocationData(blankLocationMotor);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pincode"
                  InputLabelProps={{
                    style: { fontSize: '0.8rem' },
                  }}
                  error={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                  }
                  helperText={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                      ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                      : ''
                  }
                  variant="outlined"
                  id="searchPincode"
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <IconButton onClick={handleSearchClick}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}
              disabled={false}
            />
          ) : (
            <MTextField
              label="Pincode"
              required
              value={locationData.pincode ?? ''}
              numberOnly
              disabled
            />
          )}
        </Col>
      </Row>
      <div className="mt-3">
        <MUILocationFilter
          size={{
            zone: colSize,
            state: colSize,
            district: colSize,
            city: colSize,
          }}
          filterData={{
            zone: locationData.zone,
            state: locationData.state,
            district: locationData.district,
            city: locationData.city,
          }}
          setLocationFilter={(filter: MUILocationFilterType) => {
            setLocationData({
              ...locationData,
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
              pincode: filter.pincode ?? '',
            });
          }}
          disabled={disabled}
          required={true}
          defaultLocationOptions={defaultLocationOptions}
          selectedLeadTypeId={selectedLeadTypeId}
          setZoneName={(data) => setZoneName(data)}
          setStateName={(data) => setStateName(data)}
          setDistrictName={(data) => setDistrictName(data)}
          setVillageName={(data) => setVillageName(data)}
          setInputValue={(data: any) => {
            setInputValue(String(data));
          }}
          searchTerm={searchTerm}
          setSearchTerm={(data: any) => {
            setSearchTerm(data);
          }}
        />
      </div>
      <Row>
        <Col xs={12} md={4} className="col-margin">
          <MSelect
            label="Risk Coverage"
            required
            disabled={disabled}
            options={leadTypeRiskCoverageDropOptions}
            value={leadMotorDetails?.riskCoverage ?? ''}
            onChange={async (e) => {
              const selectedRiskCoverage =
                await leadTypeRiskCoverageDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadMotorDetails({
                ...leadMotorDetails,
                riskCoverage: Number(e.target.value),
                riskCoverageName: selectedRiskCoverage?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MSelect
            label="Vehicle Type"
            required
            disabled={disabled}
            options={leadTypeVehicleTypeDropOptions}
            value={leadMotorDetails?.vehicleType ?? ''}
            onChange={async (e) => {
              const selectedVehicleType =
                await leadTypeVehicleTypeDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadMotorDetails({
                ...leadMotorDetails,
                vehicleType: Number(e.target.value),
                vehicleTypeName: selectedVehicleType?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MTextField
            label="Make"
            required
            value={leadMotorDetails?.make}
            onChange={(e) => {
              setLeadMotorDetails({
                ...leadMotorDetails,
                make: e.target.value,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Owner name as per RC"
            required={false}
            value={leadMotorDetails?.OwnerNameASPerRC}
            onChange={(e) => {
              setLeadMotorDetails({
                ...leadMotorDetails,
                OwnerNameASPerRC: e.target.value,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            required
            label="Vehicle Regn No"
            value={leadMotorDetails?.VehicleRegnNo}
            onChange={(e) => {
              setLeadMotorDetails({
                ...leadMotorDetails,
                VehicleRegnNo: e.target.value,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Aadhar number"
            required={false}
            value={leadMotorDetails?.AadharNumber}
            onChange={(e) => {
              if (e.target.value.length <= 12) {
                setLeadMotorDetails({
                  ...leadMotorDetails,
                  AadharNumber: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <DatePicker
            label="Date of birth"
            disabled={disabled}
            required={true}
            value={leadMotorDetails?.date}
            maxDate={moment().toDate()}
            onChange={(date) => {
              setLeadMotorDetails({
                ...leadMotorDetails,
                date: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <DatePicker
            label="Timeframe of purchase"
            disabled={disabled}
            required={true}
            value={leadMotorDetails?.timeframeOfPurchase}
            minDate={moment().toDate()}
            onChange={(date) => {
              setLeadMotorDetails({
                ...leadMotorDetails,
                timeframeOfPurchase: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <div className="d-flex flex-column">
            <Label
              className="mb-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Ever Insured
            </Label>

            <RadioGroup
              row
              name="everInsured"
              value={leadMotorDetails?.everInsured ?? ''}
              onChange={(e) => {
                setLeadMotorDetails({
                  ...leadMotorDetails,
                  everInsured: e.target.value,
                });
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio size="small" />}
                disabled={disabled}
                label="Yes"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />

              <FormControlLabel
                value="no"
                control={<Radio size="small" />}
                disabled={disabled}
                label="No"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />
            </RadioGroup>
          </div>
        </Col>
        <Col xs={12} md={4} className="activity-log-margin create-input">
          <div className="mb-2">
            <Label
              for="comment"
              className="mt-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Additional information
            </Label>
            <Input
              id="AdditionalInformation"
              name="AdditionalInformation"
              type="textarea"
              value={leadMotorDetails?.additionalInformation}
              maxLength={500}
              className="rounded border model-comment-area comment-input"
              onChange={(event) => {
                setLeadMotorDetails({
                  ...leadMotorDetails,
                  additionalInformation: event.target.value,
                });
              }}
              readOnly={disabled}
              style={
                disabled
                  ? {
                      color: '#999',
                    }
                  : {}
              }
            />
          </div>
        </Col>
      </Row>

      {leadMotorList.length > 0 ? (
        <Row className="mt-4">
          <Col xs={12} md={12}>
            <KTable
              data={leadMotorList}
              tableParentClass=""
              columnHeader={VIEW_LEADMOTORDETAILS_HEADER}
              isLoading={false}
              showNoDataFoundMsg={false}
              onAction={(action, rowData) => {
                if (rowData?.action === CLICK_ACTIONS.DELETE) {
                  handleRemoveMotorLead(action.id);
                }
              }}
            />
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default MotorSectionPage;
